/* eslint-disable no-console */
/* eslint-disable camelcase */
import axios from 'axios';
import { get, isEmpty, replace } from 'lodash';
import { ACCEPT_LANGUAGE_HEADER, API_ROOT, HOST_ROOT } from '../../apiConfig';
import { ROUTES } from '../../constants';
import { hashAffiliateUtms } from './WebAnalytics';

function rejectFunc(err, errorHandler) {
  if (errorHandler) {
    errorHandler(err);
  } else {
    console.log(err);
  }
}
function resolveFunc(response, cb, errCb) {
  const { result, success, session_id, subscription_tier_id } = response.data;
  const formData = get(response, 'data.form-data', {});
  // Accept standard HTTP success status codes (200, 201) or Soothe API success indicators
  const isHttpSuccess = response.status === 200 || response.status === 201;
  const hasSootheApiSuccess = result || success || session_id || subscription_tier_id || !isEmpty(formData);
  
  if ((isHttpSuccess || hasSootheApiSuccess) && cb) {
    cb(response);
  } else {
    rejectFunc({ response }, errCb);
  }
}

function credLangConfig() {
  return {
    withCredentials: true,
    headers: { ...ACCEPT_LANGUAGE_HEADER.headers },
  };
}

export function getChatsOfCurrentUser(callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/chats`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getClient(callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/clients`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getClientById(id, callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/clients/${id}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function updateClientById(id, client, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/clients/${id}`, {
    client,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getSessionParams(user_id, callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/clients/${user_id}/sift_science_params`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getEmail(email, callBackFunc, errorHandler) {
  const frmtdEmail = encodeURIComponent(replace(email, /\s/g, ''));
  axios.get(`${API_ROOT}/users/email_exists?email=${frmtdEmail}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getPhoneNumber(mobile_number, callBackFunc, errorHandler) {
  const frmtdMobile = replace(mobile_number, /\+/g, '%2B');
  axios.get(`${API_ROOT}/clients/mobile_number_exists?mobile_number=${frmtdMobile}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function userSignup(headers, user, callBackFunc, errorHandler) {
  axios.post(`${HOST_ROOT}/users`, {
    user,
    react_flow: true,
    attribution: hashAffiliateUtms(),
  }, { headers })
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function userSignin(headers, user, callBackFunc, errorHandler) {
  axios.post(`${HOST_ROOT}${ROUTES.oldUserSignin}`, {
    user, react_flow: true,
  }, { headers })
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function fbSignup(user, callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/users/facebook`, {
    user,
    react_flow: true,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function fbSignin(user, callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/sessions/facebook`, {
    user,
    react_flow: true,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function gglSignup(user, callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/users/google`, {
    user,
    react_flow: true,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function gglSignin(user, callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/sessions/google`, {
    user,
    react_flow: true,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getAnonymousUser(callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/anonymous_user`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function sendAttributions(attribution, user_id, callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/attributions`, {
    attribution,
    user_id,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function verifyPhoneNumber(user_id, inquiry_id, callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/users/${user_id}/verify_phone_number`, {
    inquiry: {
      id: inquiry_id,
      // inquiry, the id is returned from the Persona SDK after we do their verification process.
      // We are having the backend do a double check to verify that it's confirmed on our end.
    },
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getAddressesOfCurrentUser(userId, callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/users/${userId}/addresses`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}

export function addAddressForCurrentUser(address, callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/addresses`, {
    address,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}

export function updateAddressOfCurrentUser(addressId, address, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/addresses/${addressId}`, {
    address,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}

export function deleteAddressOfCurrentUser(addressId, callBackFunc, errorHandler) {
  axios.delete(`${API_ROOT}/addresses/${addressId}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}

export function setDefaultAddress(addressId, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/addresses/${addressId}`, {
    address: { default: 1 },
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
// if show means get single address record.. what is the difference between users/ and clients/
export function getCreditCardsOfUser(userId, callBackFunc, errorHandler) {
  if (userId) {
    axios.get(
      `${API_ROOT}/users/${userId}/credit_cards`,
      { withCredentials: true },
      ACCEPT_LANGUAGE_HEADER,
    )
      .then((response) => resolveFunc(response, callBackFunc))
      .catch((err) => rejectFunc(err, errorHandler));
  }
}
export function createCreditCardOfUser(creditCard, callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/credit_cards/create_with_user_id/`, { credit_card: creditCard }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function setDefaultCreditCardOfUser(creditCardId, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/credit_cards/${creditCardId}`, { credit_card: { default: 1 } }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function deleteCreditCardOfUser(creditCardId, callBackFunc, errorHandler) {
  if (creditCardId) {
    axios.delete(
      `${API_ROOT}/credit_cards/${creditCardId}`,
      { withCredentials: true },
      ACCEPT_LANGUAGE_HEADER,
    )
      .then((response) => resolveFunc(response, callBackFunc))
      .catch((err) => rejectFunc(err, errorHandler));
  }
}
export function logoutCurrentUser(callBackFunc, errorHandler) {
  axios.delete(
    `${HOST_ROOT}/users/sign_out`,
    { withCredentials: true },
    ACCEPT_LANGUAGE_HEADER,
  )
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getCartWithSalesTax(cartId, callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/v7/carts/${cartId}/calculate_sales_tax`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getCartReceipt(cartId, callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/v7/carts/${cartId}/cart_receipt`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getAvailableTherapistsWithTimeSlots(
  cartId,
  cartProductId,
  session_date,
  callBackFunc,
  errorHandler,
) {
  axios.get(`${API_ROOT}/v7/carts/${cartId}/cart_products/${cartProductId}/available_therapists?session_date=${session_date}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function removeProFromList(cartId, cartProductId, therapist_id, callBackFunc, errorHandler) {
  axios.delete(
    `${API_ROOT}/v7/carts/${cartId}/cart_products/${cartProductId}/remove_pro_request`,
    { data: { therapist_id } },
    { withCredentials: true },
    ACCEPT_LANGUAGE_HEADER,
  )
    .then((resp) => {
      const { result } = resp.data;
      if (result && callBackFunc) {
        callBackFunc(resp);
      }
    }).catch((err) => {
      if (errorHandler) {
        errorHandler(err);
      } else {
        console.log(err);
      }
    });
}
export function triggerResetPasswordEmail(user, callBackFunc, errorHandler) {
  // it will send an email to the user with a deep link like the following
  // https://soothe.onelink.me/9Hnv/kk9qd5s7?reset_password_token=N2x2Jt2xiZroezkcEiHx&token_expiry=2023-10-02T19:23:28-0700
  axios.post(`${API_ROOT}/users/password/send_reset_token`, {
    user,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
  // user: {
  //     "email": "test@soothe.com",      <-- not required if token is provided
  //     "reset_password_token": "TgvJtBZJ7aMvaMyBsYCs"   <-- not required if email is provided
  //   }
}
export function resetPasswordSubmission(user, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/users/password`, {
    user,
    // : {
    //     "email": "test@soothe.com",        <-- required if token not provided
    //     "current_password": "password",    <-- required if token not provided
    //     "password": "NewPassword2@",
    //     "reset_password_token": "TgvJtBZJ7aMvaMyBsYCs" // optional
    // <-- required if email and current_password are not provided
    //   }
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function presignAvatar(userId, callBackFunc, errorHandler) {
  axios
    .post(
      `${API_ROOT}/users/${userId}/avatar_s3_presign`,
      {},
      { withCredentials: true },
      ACCEPT_LANGUAGE_HEADER
    )
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
    //Response: {"form-data":{"key":"user/1574909/avatar/b2317488-f3df-4a41-8527-0dfcd0e27024",
    // "success_action_status":"201",
    // "acl":"public-read","policy":"eyJleHBpcmF0aW9uIjoiMjAyNS0wOC0yMFQxMzoxMToyMloiLCJjb25kaXRpb25zIjpbeyJidWNrZXQiOiJzb290aGUtc3RhZ2luZy1wdWJsaWMtYXNzZXRzIn0seyJrZXkiOiJ1c2VyLzE1NzQ5MDkvYXZhdGFyL2IyMzE3NDg4LWYzZGYtNGE0MS04NTI3LTBkZmNkMGUyNzAyNCJ9LHsic3VjY2Vzc19hY3Rpb25fc3RhdHVzIjoiMjAxIn0seyJhY2wiOiJwdWJsaWMtcmVhZCJ9LHsieC1hbXotY3JlZGVudGlhbCI6IkFLSUEyQVlUM1JVRUtHQldVSUpNLzIwMjUwODIwL3VzLWVhc3QtMS9zMy9hd3M0X3JlcXVlc3QifSx7IngtYW16LWFsZ29yaXRobSI6IkFXUzQtSE1BQy1TSEEyNTYifSx7IngtYW16LWRhdGUiOiIyMDI1MDgyMFQxMjExMjJaIn1dfQ==",
    // "x-amz-credential":"AKIA2AYT3RUEKGBWUIJM/20250820/us-east-1/s3/aws4_request",
    // "x-amz-algorithm":"AWS4-HMAC-SHA256","x-amz-date":"20250820T121122Z",
    // "x-amz-signature":"b0c934d5d8560caca1ca90f36c2b64d5a2c0a6f545e8ba3bb52d38d446ebc1ae"},
    // "url":"https://soothe-staging-public-assets.s3.amazonaws.com",
    // "key":"user/1574909/avatar/b2317488-f3df-4a41-8527-0dfcd0e27024"}
}
export function uploadAvatar(url, formData, callBackFunc, errorHandler) {
  axios
    .post(url, formData, { 
      withCredentials: false, // S3 uploads don't need credentials and will fail with CORS if included
      // Don't set Content-Type header - let axios set it automatically for FormData
      // Don't include ACCEPT_LANGUAGE_HEADER as this is an S3 upload, not Soothe API
    })
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => {
      // Handle CORS errors where upload succeeded but browser blocks response
      // S3 upload may succeed (201) but browser blocks due to CORS policy in dev environment
      if (err.response && (err.response.status === 201 || err.response.status === 200)) {
        // Upload succeeded despite CORS error - use resolveFunc to handle it
        resolveFunc(err.response, callBackFunc, errorHandler);
      } else if (err.request && err.request.status === 201) {
        // Handle case where we can detect 201 status from the request
        resolveFunc({ status: 201, data: {} }, callBackFunc, errorHandler);
      } else {
        rejectFunc(err, errorHandler);
      }
    });
    // Body: MultiPartFormData (with the previous s3 parameters and a file as image/jpeg or png locally persisted with the new avatar)

  // FormData should contain:
  // - key (S3 key)
  // - success_action_status (201)
  // - acl (public-read)
  // - policy (S3 policy)
  // - x-amz-credential (AWS credential)
  // - x-amz-algorithm (AWS4-HMAC-SHA256)
  // - x-amz-date (date)
  // - x-amz-signature (signature)
  // - file (the actual file)
}
export function saveAvatar(avatar_url, callBackFunc, errorHandler) {
  axios
    .post(
      `${API_ROOT}/users/v1/avatar`,
      { user: { avatar_url } },
      { withCredentials: true },
      ACCEPT_LANGUAGE_HEADER
    )
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
    // avatar_url = "$s3Data.getUrl()/$s3Data.getKey()"
}
export function getRecommendedPros(cartId, cartProductId, callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/v7/carts/${cartId}/cart_products/${cartProductId}/recommended_providers`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function authTokenPost(callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/auth_token`, {}, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
/**
 * One-Off Event APIs
 */
export function getProductsByParams(params, callBackFunc, errorHandler) {
  const paramStr = !params || isEmpty(params) ? "" : Object.keys(params).map((key) => `${key}=${params[key]}`).join('&');
  axios.get(`${API_ROOT}/v7/products?${paramStr}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function postEvent(event, callBackFunc, errorHandler) {
  // "event": {
  //            "type": "personal",
  //            "session_date": "2024-11-20",
  //            "session_time": "13:00",
  //            "address_id": 37551,
  //            "credit_cart_id": 123,
  //            "option_ids": [1, 2, 3],
  //            "no_pros": 2
  //          }
  // TODO: Add more fields as needed
  axios.post(`${API_ROOT}/v7/events`, {
    event,
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function contactRepresentative(payload, callBackFunc, errorHandler) {
  // { "first_name: "test", ##REQUIRED
  //   "last_name: "user", ##REQUIRED
  //   "email": "test_user@soothe.com", ##REQUIRED
  //   "phone": "+13104567890", ##REQUIRED
  //   "occasion": "Birthday", ##REQUIRED
  //   "start_time": "2024-11-22 15:00:00", ##REQUIRED Standard date format UTC or assume timezone from address??
  //   "end_time": "2024-11-22 18:00:00", ##REQUIRED Standard date format UTC or assume timezone from address??
  //   "address_line_1": "1800 Highland Ave" ##REQUIRED, from google API
  //   "address_line_2": "", from google API
  //   "city": "Los Angeles" ##REQUIRED, from google API
  //   "state": "CA" ##REQUIRED, from google API
  //   "zip_code": "90028" ##REQUIRED,f rom google API
  //   "country": "US" ##REQUIRED, from google API
  //   "no_pros": 3 ##REQUIRED,
  //   "guest_no": 15 ##REQUIRED,
  //   "kind": "personal" ##REQUIRED, [personal or corporate]
  //   "company": "", Name of company if corporate
  //   "date": "2024-11-22" ##REQUIRED
  //   }
  axios.post(`${API_ROOT}/v7/events/contact_me`, {
    ...payload
  }, credLangConfig())
    .then((response) => resolveFunc(response, callBackFunc))
    .catch((err) => rejectFunc(err, errorHandler));
}

export function initCartJson(cart_json, callBackFunc, errorHandler) {
  if (cart_json) {
    axios.post(`${API_ROOT}/guest/init_guest/init_guest_cart`,
      {
        "cart_json": JSON.stringify(cart_json)
      }, credLangConfig())
      .then((response) => resolveFunc(response, callBackFunc))
      .catch((err) => rejectFunc(err, errorHandler));
  }
}

export function calculateEventProviders({ session_date,
  session_time,
  session_end_time,
  number_of_guests,
  option_id,
  override_number_of_providers }, callBackFunc, errorHandler) {
  axios.post(`${API_ROOT}/guest/carts/calculate_providers_needed`, {
    cart: {
      session_date,
      session_time,
      session_end_time,
      number_of_guests,
      option_id,
      ...override_number_of_providers != null ? { override_number_of_providers } : {}
    }
  }, credLangConfig())
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}

/** 
 * SOOTHEPASS APIs
*/
export function changeSoothePassPlan(clientId, soothe_pass_subscription_id, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/clients/${clientId}/soothe_pass/${soothe_pass_subscription_id}`, {}, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function pauseSoothePass(clientId, soothe_pass_subscription_id, payload, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/clients/${clientId}/soothe_pass/${soothe_pass_subscription_id}/pause`, payload, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function resumeSoothePass(clientId, soothe_pass_subscription_id, credit_card_id, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/clients/${clientId}/soothe_pass/${soothe_pass_subscription_id}/resume`, {
    subscription: {
      credit_card_id
    }
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function cancelSoothePass(clientId, soothe_pass_subscription_id, reason_id, callBackFunc, errorHandler) {
  axios.delete(`${API_ROOT}/clients/${clientId}/soothe_pass/${soothe_pass_subscription_id}?client_subscription_cancellation_reason_id=${reason_id}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getSoothePassDetails(clientId, soothe_pass_subscription_id, callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/clients/${clientId}/soothe_pass/${soothe_pass_subscription_id}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function soothe_pass_cancellation_reasons(callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/soothe_pass_cancellation_reasons`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function soothe_pass_subscriptions(params = {}, callBackFunc, errorHandler) {
  const { city_id, zip_code } = params;
  
  // Build query parameters based on what's provided
  const queryParams = [];
  if (city_id) {
    queryParams.push(`city_id=${city_id}`);
  }
  if (zip_code) {
    queryParams.push(`zip_code=${zip_code}`);
  }
  
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  
  axios.get(`${API_ROOT}/subscription_tiers${queryString}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
// TODO: This is not used anywhere yet
export function changePlanToSoothePass({client_id, soothe_pass_subscription_id}, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/clients/${client_id}/soothe_pass/soothe_pass_subscription_id`, { soothe_pass_subscription_id }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function createSoothePassSubscription(client_id,subscription, callBackFunc, errorHandler) {
//   "subscription" : {
//   "city_id" : 2,
//   "subscription_tier_id" : 115,
//   "credit_card_id" : 4875
//  }
  axios.post(`${API_ROOT}/clients/${client_id}/soothe_pass`, { subscription }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function updateSoothePassPaymentMethod(clientId, soothe_pass_subscription_id, subscription, callBackFunc, errorHandler) {
  axios.put(`${API_ROOT}/clients/${clientId}/soothe_pass/${soothe_pass_subscription_id}`, {
    subscription
  }, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getSoothePassFAQ(client_id, subscription_tier_id, callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/clients/${client_id}/soothe_pass/${subscription_tier_id}`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}
export function getSoothePassDiscountsAvailability(callBackFunc, errorHandler) {
  axios.get(`${API_ROOT}/soothe_pass_discounts/availability`, { withCredentials: true }, ACCEPT_LANGUAGE_HEADER)
    .then((response) => resolveFunc(response, callBackFunc, errorHandler))
    .catch((err) => rejectFunc(err, errorHandler));
}